<template>
  <div class="box" style="position: relative">
    <div :class="left ? '' : 'vtk-width-2'" class="d-inline-block text-right" :style="Tstyle" style="min-width: 120px !important">
      <span v-if="must" class="red--text mt-3">*</span>
      <span>{{ label }}</span>
    </div>
    <div class="d-inline-block vtk-width-7" style="min-width: 300px;">
      <slot></slot>
    </div>
    <div v-if="left && help" class="box_help tips py-3 px-4" style="width: calc(30% - 160px)">
      <p class="mb-2 font-weight-bold body-1">{{ label }}</p>
      <span v-html="help"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "VtkFormItem",
  inheritAttrs: false,
  props: {
    label: { type: String, default: null },
    must: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    Tstyle: { type: String, default: null },
    help: { type: String, default: null },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.box:hover > .box_help {
  display: inline-block !important;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
}
.box_help {
  display: none;
}
.tips {
  position: absolute;
  right: 8px;
  top: 0;
  border: 1px rgba(175, 175, 175, 0.341) solid;
}
</style>